import React, { useEffect, useState } from 'react';
import { Badge, Button, Table } from 'react-bootstrap';
import { useNavigate, useParams } from "react-router-dom";
import './taskstab.css';
import tableattachmenticon from '../../../assets/images/tableattachmenticon.svg';
import TaskList from '../../../interfaces/task/TaskList';
import Avatar from '../../../interfaces/avatar/Avatar';
import { formatDateToMMDDYYYY, calculateDateProximity } from '../../../utilities/dateUtils';
import { useAuth } from '../../../firebase/AuthProvider';
import { fetchTasksWithCache } from '../../../services/taskServices/TaskService';
import { getAvatarsFromStorage } from '../../../services/fileServices/FileService';
import avtar from "../../../assets/images/avtar.png";
import Loader from '../loader/Loader';


const Taskstab: React.FC = () => {
    const navigate = useNavigate();
    const { currentUser } = useAuth();
    const { userId } = useParams();

    const [tasks, setTasks] = useState<TaskList[]>([]);
    const [avatars, setAvatars] = useState<Avatar[] | null>([]);
    const [page, setPage] = useState<number>(1);
    const [displayCount, setDisplayCount] = useState<number>(10);
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const findAvatarById = (userId: string): string | null => {
        const avatarObj = avatars?.find((avatar) => avatar.id === userId);
        return avatarObj ? `data:image/png;base64,${avatarObj.avatar}` : null;
    };

    const loadMore = () => {
        setPage((currentPage) => currentPage + 1);
    };

    useEffect(() => {

    }, [tasks])

    useEffect(() => {
        if (currentUser && userId) {
            const fetchData = async () => {
                setIsLoading(true);
                const authToken = await currentUser.getIdToken();
                const tasksForThisUser = await fetchTasksWithCache(
                    authToken,
                    userId
                );
                if (tasksForThisUser) setTasks(tasksForThisUser)
                setIsLoading(false);
            }
            fetchData();
        }
    }, [userId])

    useEffect(() => {
        const storedAvatars = getAvatarsFromStorage();
        setAvatars(storedAvatars);
    }, []);

    return (
        <>
            {isLoading && <Loader />}
            {/* <div className="common_content_inner mby_t_24">
                {tasks && <div className="text-end pb-2 text-muted">{tasks.length} tasks</div>}
                <Table responsive className="common_table">
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Attachment</th>
                            <th>Participant</th>
                            <th>Type</th>
                            <th>Assignee</th>
                            <th>Due Date</th>
                            <th>Proximity</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tasks.slice(0, page * displayCount).map((task, index) => {
                            const proximity = calculateDateProximity(task.endDate);
                            return (
                                <tr key={index}>
                                    <td>{task.title}</td>
                                    <td>
                                        {task.hasAttachments ? (
                                            <img src={tableattachmenticon} alt="attachment" />
                                        ) : (
                                            "-"
                                        )}
                                    </td>
                                    <td>
                                        {task.participant?.firstName
                                            ? `${task.participant.firstName[0]}. ${task.participant.lastName}`
                                            : "N/A"}
                                    </td>
                                    <td>
                                        {task.subType?.type
                                            ? task.subType.type
                                                .toLowerCase()
                                                .split(" ")
                                                .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
                                                .join(" ")
                                            : "N/A"}
                                    </td>
                                    <td>
                                        <div className="stack_img_flx">
                                            {task.assignees
                                                .filter((a) => !a.isReporter)
                                                .map((user, idx) => {
                                                    const avatarUrl = findAvatarById(user.user.id);
                                                    return (
                                                        <div key={idx}
                                                            title={`${user.user.firstName} ${user.user.lastName}`}
                                                            className="stack_img"
                                                        >
                                                            {avatarUrl ? (
                                                                <img src={avatarUrl || avtar} alt={user.user.firstName} />
                                                            ) : (
                                                                <div className="stack_img_txt">
                                                                    {user.user.firstName[0]}
                                                                    {user.user.lastName[0]}
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    </td>
                                    <td>{formatDateToMMDDYYYY(task.endDate)}</td>
                                    <td>
                                        <Badge bg={proximity === 'Overdue' ? 'danger' : 'secondary'}>
                                            {proximity}
                                        </Badge>
                                    </td>
                                    <td>
                                        <Badge bg="success">
                                            {task.status?.name
                                                .toLowerCase()
                                                .split(" ")
                                                .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
                                                .join(" ")}
                                        </Badge>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </div>
            {page * displayCount < tasks.length && (
                <div className="flex justify-center mby_t_24">
                    <Button variant='secondary' className="btn_sm" onClick={loadMore}>
                        Load More
                    </Button>
                </div>
            )} */}

            <div className="common_content_inner mt-6">
                {tasks && (
                    <div className="text-right pb-2 text-sm text-gray-500">
                        {tasks.length} tasks
                    </div>
                )}

                <div className="overflow-x-auto w-full">
                    <table className="min-w-[1100px] w-full border-collapse text-sm">
                        {/* <thead className=" text-left text-gray-600">
                            <tr>
                                <th className=" font-medium">Title</th>
                                <th className=" font-medium">Attachment</th>
                                <th className=" font-medium">Participant</th>
                                <th className=" font-medium">Type</th>
                                <th className=" font-medium">Assignee</th>
                                <th className=" font-medium">Due Date</th>
                                <th className=" font-medium">Proximity</th>
                                <th className=" font-medium">Status</th>
                            </tr>
                        </thead> */}

                        <tbody className="divide-y divide-gray-200 bg-white w-full miw-w-[1100px]">
                            {tasks.slice(0, page * displayCount).map((task, index) => {
                                const proximity = calculateDateProximity(task.endDate);

                                return (
                                    <tr key={index}
                                        className="flex items-center gap-x-3 px-3 my-1 rounded-lg h-[50px] w-[100%]"
                                        style={{
                                            borderTop: "1px solid #C9C9C9",
                                            borderRight: "1px solid #C9C9C9",
                                            borderBottom: "1px solid #C9C9C9",
                                            borderLeft: "1px solid #C9C9C9",

                                        }}
                                    >
                                        <td className="font-medium text-gray-900 w-[25%] ">
                                            {task.title}
                                        </td>

                                        <td className="text-center w-[5%] ">
                                            {task.hasAttachments ? (
                                                <img
                                                    src={tableattachmenticon}
                                                    alt="attachment"
                                                    className="mx-auto h-4 w-4"
                                                />
                                            ) : (
                                                "-"
                                            )}
                                        </td>

                                        <td className="w-[10%] ">
                                            {task.participant?.firstName
                                                ? `${task.participant.firstName[0]}. ${task.participant.lastName}`
                                                : "N/A"}
                                        </td>

                                        <td className="w-[10%] ">
                                            {task.subType?.type
                                                ? task.subType.type
                                                    .toLowerCase()
                                                    .split(" ")
                                                    .map(s => s.charAt(0).toUpperCase() + s.slice(1))
                                                    .join(" ")
                                                : "N/A"}
                                        </td>

                                        <td className="w-[7%] ">
                                            <div className="flex -space-x-2">
                                                {task.assignees
                                                    .filter(a => !a.isReporter)
                                                    .map((user, idx) => {
                                                        const avatarUrl = findAvatarById(user.user.id);

                                                        return (
                                                            <div
                                                                key={idx}
                                                                title={`${user.user.firstName} ${user.user.lastName}`}
                                                                className="flex h-8 w-8 items-center justify-center rounded-full border border-white bg-gray-200 text-xs font-semibold text-gray-700"
                                                            >
                                                                {avatarUrl ? (
                                                                    <img
                                                                        src={avatarUrl || avtar}
                                                                        alt={user.user.firstName}
                                                                        className="h-full w-full rounded-full object-cover"
                                                                    />
                                                                ) : (
                                                                    <>
                                                                        {user.user.firstName[0]}
                                                                        {user.user.lastName[0]}
                                                                    </>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        </td>

                                        <td className="w-[10%] ">
                                            {formatDateToMMDDYYYY(task.endDate)}
                                        </td>

                                        <td className="w-[13%]  flex justify-center">
                                            <span
                                                className={`inline-flex rounded-full px-3 py-1 text-xs font-medium ${proximity === "Overdue"
                                                    ? " text-red-700"
                                                    : "bg-gray-100 text-gray-700"
                                                    }`}
                                            >
                                                {proximity}
                                            </span>
                                        </td>

                                        <td className="w-[15%]  flex justify-center">
                                            <span className="inline-flex rounded-full bg-green-100 px-3 py-1 text-xs font-medium text-green-700">
                                                {task.status?.name
                                                    .toLowerCase()
                                                    .split(" ")
                                                    .map(s => s.charAt(0).toUpperCase() + s.slice(1))
                                                    .join(" ")}
                                            </span>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>


            </div>

            {page * displayCount < tasks.length && (
                <div className="mt-6 flex justify-center">
                    <button
                        onClick={loadMore}
                        className="rounded-md bg-gray-200 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-300 transition"
                    >
                        Load More
                    </button>
                </div>
            )}


        </>
    );
};

export default Taskstab;
